import TaxiOfficerDetailsParams from "./taxi-officer-details-params";
import TaxiOfficerDetailsRequest from "../../../api/raily/taxi-officer/details/taxi-officer-details.request";

const create = (
  params: TaxiOfficerDetailsParams,
): TaxiOfficerDetailsRequest => {
  return {
    taxiOfficerUuid: params.taxiOfficerUuid,
  };
};

const taxiOfficerDetailsParamsFactory = {
  create,
};

export default taxiOfficerDetailsParamsFactory;
